import { Outlet } from '@tanstack/react-router';
import React, { ReactElement } from 'react';

function SnapshotsContainer(): ReactElement {
  return <Outlet />;
}

export default SnapshotsContainer;
